import { useCallback, useRef, useState } from "react";
import apiV2 from "../../../services/apiV2";

export default function useGoogleCalendarOAuth() {
	const [loading, setLoading] = useState(false);
	const popupRef = useRef(null);
	const pollRef = useRef(null);

	const clearPoll = useCallback(() => {
		if (pollRef.current) {
			clearInterval(pollRef.current);
			pollRef.current = null;
		}
	}, []);

	const connect = useCallback(
		async (onPopupClosed) => {
			setLoading(true);
			clearPoll();
			try {
				const { data } = await apiV2.get(
					"/integrations/google-calendar/oauth/start"
				);
				const authUrl = data?.authUrl;
				if (!authUrl) {
					throw new Error("authUrl_missing");
				}

				const width = 560;
				const height = 720;
				const left = window.screenX + (window.outerWidth - width) / 2;
				const top = window.screenY + (window.outerHeight - height) / 2;
				const popup = window.open(
					authUrl,
					"google-calendar-oauth",
					`width=${width},height=${height},left=${left},top=${top}`
				);
				popupRef.current = popup;

				if (!popup) {
					window.location.href = authUrl;
					return;
				}

				pollRef.current = setInterval(() => {
					if (popup.closed) {
						clearPoll();
						onPopupClosed?.();
					}
				}, 700);
			} finally {
				setLoading(false);
			}
		},
		[clearPoll]
	);

	const disconnect = useCallback(async () => {
		setLoading(true);
		try {
			await apiV2.delete("/integrations/google-calendar");
		} finally {
			setLoading(false);
		}
	}, []);

	return { connect, disconnect, loading };
}
